import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useRef } from 'react';
import Tracker from '@openreplay/tracker';
import trackerAssist from '@openreplay/tracker-assist';
import trackerAxios from '@openreplay/tracker-axios';
import _get from 'lodash/get';
import _isNil from 'lodash/isNil';
import _isFunction from 'lodash/isFunction';
import { getEmailId, isEmpty } from '../../utils/helper';
const isOpenReplayEnvVariableSet = () => {
  const {
    OPEN_REPLAY_PROJECT_KEY,
    OPEN_REPLAY_PROJECT_ID
  } = process.env;
  return OPEN_REPLAY_PROJECT_KEY && OPEN_REPLAY_PROJECT_ID;
};
const getSessionInfo = () => {
  const openreplayHostFunc = _get(window, '__OPENREPLAY__.app.getHost');
  const openreplaySessionIDFunc = _get(window, '__OPENREPLAY__.app.getSessionID');
  if (_isFunction(openreplaySessionIDFunc) && _isFunction(openreplayHostFunc)) {
    return {
      sessionId: window.__OPENREPLAY__.app.getSessionID(),
      sessionUrl: "".concat(window.__OPENREPLAY__.app.getHost(), "/").concat(process.env.OPEN_REPLAY_PROJECT_ID, "/session/").concat(window.__OPENREPLAY__.app.getSessionID())
    };
  }
  return {};
};
const updateLiveAssistStatus = status => {
  const func = _get(window, 'TAP_CHAT.updateLiveAssistStatus');
  if (_isFunction(func)) {
    const {
      sessionId,
      sessionUrl
    } = getSessionInfo();
    window.TAP_CHAT.updateLiveAssistStatus({
      sessionId,
      sessionUrl,
      status
    });
  }
};
function OpenReplay(props) {
  const {
    userId,
    axiosInstance,
    metadata,
    openReplayOptions
  } = props;
  const thisRef = useRef({});
  useEffect(() => {
    const axiosInstanceToUse = axiosInstance;
    if (isOpenReplayEnvVariableSet()) {
      var _thisRef$current;
      let tracker = (_thisRef$current = thisRef.current) === null || _thisRef$current === void 0 ? void 0 : _thisRef$current.tracker;
      if (!tracker) {
        var _openReplayOptions$tr;
        tracker = new Tracker(_objectSpread({
          projectKey: process.env.OPEN_REPLAY_PROJECT_KEY,
          __DISABLE_SECURE_MODE: process.env.NODE_ENV === 'development',
          ingestPoint: "".concat(process.env.OPEN_REPLAY_ORG_URL, "/ingest"),
          capturePerformance: false,
          autoResetOnWindowOpen: true,
          userID: userId,
          captureIFrames: true,
          verbose: true
        }, openReplayOptions.tracker || {}));
        thisRef.current.tracker = tracker;
        // If we pass null axios instance, open replay tracker won't be initialized.
        if (!_isNil(axiosInstanceToUse) || !_isNil((_openReplayOptions$tr = openReplayOptions.trackerAxios) === null || _openReplayOptions$tr === void 0 ? void 0 : _openReplayOptions$tr.instance)) {
          tracker.use(trackerAxios(_objectSpread({
            instance: axiosInstanceToUse,
            // temporary -> current limitation in tracker plugin to be able to track only one axios
            failuresOnly: false,
            ignoreHeaders: ['tap-api-token', 'access_token']
          }, openReplayOptions.trackerAxios || {})));
        }
        tracker.use(trackerAssist(_objectSpread({
          controlConfirm: __('Do you want to give Remote Control to Tekion Support Agent?'),
          callConfirm: __('Do you want to accept the call from Tekion Support Agent?'),
          onCallStart: () => {
            updateLiveAssistStatus('CONNECTED');
            return () => updateLiveAssistStatus('DISCONNECTED');
          }
        }, openReplayOptions.trackerAssist || {})));
        tracker.start({
          userID: userId,
          metadata: _objectSpread(_objectSpread({}, metadata || {}), {}, {
            Email: getEmailId()
          })
        });
      } else {
        if (!isEmpty(metadata)) {
          Object.entries(metadata).forEach(_ref => {
            let [key, value] = _ref;
            tracker.setMetadata(key, value);
          });
        }
      }
    }
    return () => {
      if (isOpenReplayEnvVariableSet()) {
        const {
          tracker
        } = thisRef.current;
        if (tracker) {
          tracker.stop();
        }
      }
    };
  }, [axiosInstance, metadata, openReplayOptions.tracker, openReplayOptions.trackerAssist, openReplayOptions.trackerAxios, userId]);
  return null;
}
export default OpenReplay;